/* eslint-disable import/prefer-default-export */
export const IMPERSONATION_COOKIE_NAME = 'gmbsessimp';
